var fn = function( obj ){
var __t,__p='';
__p+='\nattribute vec2 aPosition;\nvarying vec2 vTexCoords;\n\nvoid main(void){\n  gl_Position = vec4( aPosition, 0.0, 1.0 );\n  vTexCoords = aPosition;\n}';
return __p;
};
fn.toString=fn;
module.exports = fn;